module.exports = __webpack_public_path__ + "static/media/SHIP WITH US.ac7328b4.jpg";